var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderPickingGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.025,
    height: 24.349,
    viewBox: "0 0 22.025 24.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(-104.945 109.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2699",
    "data-name": "Group 2699",
    transform: "translate(104.945 -109.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M17.662,11.063a.946.946,0,0,1-.474-.127L7.126,5.134a.95.95,0,1,1,.949-1.647l10.062,5.8a.95.95,0,0,1-.476,1.774Z",
    transform: "translate(-1.619 -0.891)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M13.163,25.409a3.191,3.191,0,0,1-1.593-.427l-7.823-4.47a3.2,3.2,0,0,1-1.6-2.758V8.808A3.2,3.2,0,0,1,3.743,6.051l7.83-4.474a3.186,3.186,0,0,1,3.183,0l7.823,4.47a3.2,3.2,0,0,1,1.6,2.758v8.945a3.2,3.2,0,0,1-1.593,2.757l-7.83,4.474A3.187,3.187,0,0,1,13.163,25.409Zm0-22.356a1.287,1.287,0,0,0-.643.172L4.69,7.7a1.288,1.288,0,0,0-.639,1.11v8.943a1.289,1.289,0,0,0,.643,1.111l7.823,4.47a1.286,1.286,0,0,0,1.289,0l7.83-4.474a1.288,1.288,0,0,0,.639-1.11V8.808A1.289,1.289,0,0,0,21.632,7.7l-7.823-4.47A1.291,1.291,0,0,0,13.163,3.053Z",
    transform: "translate(-2.15 -1.152)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M13.131,13.657a.95.95,0,0,1-.476-.128L2.895,7.883a.95.95,0,1,1,.952-1.645l9.285,5.371,9.285-5.371a.95.95,0,1,1,.952,1.645l-9.76,5.646A.95.95,0,0,1,13.131,13.657Z",
    transform: "translate(-2.118 -0.567)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M12.1,24.321a.95.95,0,0,1-.95-.95V12.1a.95.95,0,1,1,1.9,0V23.37A.95.95,0,0,1,12.1,24.321Z",
    transform: "translate(-1.088 0.028)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPickingGray);
export default __webpack_public_path__ + "static/media/OrderPickingGray.ad437231e78747505c67273d119b7207.svg";
export { ForwardRef as ReactComponent };